import { IANATimezones, Post, RootComment } from '@gcv/shared';
import { ReactComponent as Scroll } from 'assets/images/empty-states/archived-messages.svg';
import * as React from 'react';
import { Container, ContainerItem, Header, Text } from 'ui/atoms';
import { CommentContentContainer } from './comment-content-container';
import { useInjection } from 'ioc';
import { CommentsPresenter } from '../comments.presenter';
import { useComponent } from 'hooks';

interface Props extends Record<string, unknown> {
  bankId: string;
  iana_timezone: IANATimezones;
  orgId: string;
}

export const ArchivedTab: React.FC<Props> = useComponent((props) => {
  const presenter = useInjection(CommentsPresenter);
  const archivedComments =
    presenter.viewModel.post?.comments.filter((comment) => !!comment.archived_by) || [];

  return (
    <Container justify="center" width="100%" align="flex-start" padding="0px">
      {!archivedComments.length ? (
        <ContainerItem padding="45px 30px" justify="center">
          <Scroll style={{ width: '110px', marginBottom: '.5rem' }} />
          <Header content="No Archived Comments" type="h3" />
          <Text content="You haven't archived any comments yet." type="body2" sx={{ paddingTop: '8px' }} />
        </ContainerItem>
      ) : (
        archivedComments.map((comment) => (
          <CommentContentContainer
            archived
            key={comment.id}
            comment={comment}
            iana_timezone={props.iana_timezone}
            orgId={props.orgId}
            bankId={props.bankId}
          />
        ))
      )}
    </Container>
  );
});
